import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCancelSvg } from "./IconCancelSvg.mjs";
const IconCancel = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCancelSvg, ...iconProps });
};
export {
  IconCancel
};
